<template>
  <main id="landing" class="landing">
    <div class="landing-content">
      <router-link to="/enskede" class="location-section">
        <div class="logo-letters">
          <img src="~assets/logo-enskede.svg?file" alt="Enskede" class="location-logo" />
        </div>
        <div class="location-info">
          <h1>Ateljéns Pizza Enskede</h1>
          <p>Adress Nynäsvägen 320 122 34 Enskede</p>
          <p>Telefon <a href="tel:+46840919811" @click.stop>08 409 198 11</a></p>
          <p>E-post <a href="mailto:kontakt@ateljenspizza.se" @click.stop>kontakt@ateljenspizza.se</a></p>
        </div>
      </router-link>

      <router-link to="/slaktis" class="location-section">
        <div class="logo-letters">
          <img src="~assets/logo-slaktis.svg?file" alt="Slaktis" class="location-logo" />
        </div>
        <div class="location-info">
          <h1>Ateljéns Pizza Slaktis</h1>
          <p>Adress Hallvägen 9 121 62 Johanneshov</p>
          <p>Telefon <a href="tel:+46840919811" @click.stop>08 409 198 11</a></p>
          <p>E-post <a href="mailto:slaktis@ateljenspizza.se" @click.stop>slaktis@ateljenspizza.se</a></p>
        </div>
      </router-link>

      <router-link to="/haga-norra" class="location-section">
        <div class="logo-letters">
          <img src="~assets/logo-haga-norra.svg?file" alt="Haga Norra" class="location-logo" />
        </div>
        <div class="location-info">
          <h1>Ateljéns Pizza Haga Norra</h1>
          <p>Adress Mathildatorget 1 16975 Stockholm</p>
          <p>Telefon <a href="tel:+46737714480" @click.stop>073-771 44 80</a></p>
          <p>E-post <a href="mailto:haganorra@ateljenspizza.se" @click.stop>haganorra@ateljenspizza.se</a></p>
        </div>
      </router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Landing',
  mounted () {
    document.title = 'Ateljéns Pizza - Välj restaurang';
  }
};
</script>

<style lang="stylus" scoped>
@require '~global/colors'
@require '~global/breakpoints'

.landing
  min-height: 100vh
  display: flex
  align-items: center
  justify-content: center
  padding: 10rem 2rem
  background: $white

.landing-content
  text-align: center
  max-width: 900px
  width: 100%
  display: flex
  flex-direction: column
  gap: 6rem

.location-section
  text-decoration: none
  color: inherit
  display: flex
  flex-direction: column
  align-items: center
  gap: 2rem
  transition: opacity 0.3s ease

  &:hover
    opacity: 0.8

.logo-letters
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: 1rem

.location-logo
  width: 100%
  max-width: 650px
  height: auto

.location-info
  display: flex
  flex-direction: column
  gap: 0.25rem

  h1
    margin-bottom: 1.4rem
    text-transform: uppercase
    text-decoration: underline
    text-underline-offset: 4px

  p
    margin: 0.125rem 0
    text-transform: uppercase

@media (max-width: $tablet)
  .landing-content
    gap: 4rem

  .location-logo
    max-width: 500px

  .location-info
    h1
      font-size: 1.125rem

    p
      font-size: 0.8rem

@media (max-width: $mobile)
  .landing
    padding: 1.5rem

  .landing-content
    gap: 3rem

  .location-logo
    max-width: 350px


</style>
